import FeedCarousel, { SlideData } from "./FeedCarousel";

import { Comedian } from "@/data/comedians";
import { SpecialCard } from "../cards/SpecialCard";
import { SpecialRow } from "@/data/specials";

interface Props {
  specials: {
    last_playback_location: number;
    special: SpecialRow;
    comedian: Comedian;
  }[];
}

export default function ContinueWatchingFeedCarousel({ specials }: Props) {
  const handlePlaybackProgress = (
    lastPlaybackLocationSeconds: number,
    totalDurationMinutes: number
  ) => {
    const lastPlaybackLocationMinutes = lastPlaybackLocationSeconds / 60;
    const playbackProgress =
      (lastPlaybackLocationMinutes / totalDurationMinutes) * 100;

    return playbackProgress;
  };

  const slides = specials
    .map(({ last_playback_location, special, comedian }) => {
      if (special && comedian) {
        return {
          id: special.id,
          Component: (
            <div className="min-w-0 flex-grow-0 flex-shrink-0 basis-[240px] md:basis-[411px]">
              <SpecialCard
                location="feedContinueWatching"
                special={{ ...special, unlocked: true }} // everything in this carousel has already been watched, hence unlocked
                comedian={comedian}
                key={special.id}
                width={411}
                height={236}
                mobileWidth={240}
                mobileHeight={135}
                playbackProgress={handlePlaybackProgress(
                  last_playback_location,
                  special.runtime
                )}
                hideLockOverlay={true}
                useSquareImgOnMobile={false}
              />
            </div>
          ),
        };
      }
      return null;
    })
    .filter((slide) => slide !== null);

  return (
    <FeedCarousel
      title="Continue Watching"
      slides={slides as SlideData[]}
      location="feed"
    />
  );
}
